/**
 * 个人agent轮播
 */
import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import { Swiper, SwiperSlide } from 'swiper/react';
import { escRequest } from '@/common/request-esc';
import { goAgentCreate, goAgentChat } from '@/utils/go-agent-chat';

const PersonalAgent = observer(() => {
  const swiperRef = useRef(null);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [agentList, setAgentList] = useState([
    {
      title: '未命名智能体',
      icon: 'https://p2.ssl.qhimg.com/t110b9a93015c48cef4b965921d.png',
    },
    {
      title: '未命名智能体',
      icon: 'https://p2.ssl.qhimg.com/t110b9a93015c48cef4b965921d.png',
    },
    {
      title: '未命名智能体',
      icon: 'https://p2.ssl.qhimg.com/t110b9a93015c48cef4b965921d.png',
    },
  ]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (swiperRef.current) {
      const swiperInstance = swiperRef.current.swiper;
      swiperInstance.on('slideChange', () => {
        // 滚动到最后一个slide
        setIsLastSlide(swiperInstance.isEnd);
      });
    }
  }, [swiperRef]);

  // 获取个人Agent列表
  const fetchPersonalAgents = async () => {
    try {
      setLoading(true);
      const { data } = await escRequest({
        url: `${import.meta.env.VITE_SAFE_HOST}/api/agent/uc/usage/hot`
      });
      if (data?.items) {
        setAgentList(data.items);
      } else {
        setAgentList([]);
      }
    } catch (err) {
      console.error('获取个人Agent列表失败:', err);
      setAgentList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPersonalAgents();
  }, []);

  // 处理Agent点击
  const handleAgentClick = agent => {
    console.log('点击Agent:', agent);
    goAgentChat(agent);
  };

  return (
    <div className="max-w-800px min-w-652px w-full mt-44px mb-4px">
      <div className="flex items-center text-black">
        <span className="text-14px font-bold">个人热门Agent</span>
        <div className="ml-auto flex gap-12px">
          <div className="agent-swiper-btn-prev size-20px vh-center cursor-pointer transform rotate-[180deg]">
            <SVGPureIcon
              name="swiper_arrow"
              className="w-8px h-13px text-black"
            />
          </div>
          <div className="agent-swiper-btn-next size-20px vh-center cursor-pointer">
            <SVGPureIcon
              name="swiper_arrow"
              className="w-8px h-13px text-black"
            />
          </div>
        </div>
      </div>
      <div className={['flex']}>
        <div
          className={[
            'w-138px h-116px p-16px gap-12px cursor-pointer',
            'bg-[#F0F7FF] border-1px border-dashed border-[#BDD7FF] rounded-12px',
            'mr-16px mt-16px flex flex-col items-center justify-center flex-shrink-0',
            'hover:border-[#356DEE] hover:rounded-12px',
          ]}
        >
          <div className="w-[48px] h-[48px] rounded-full relative bg-[rgba(53,109,238,0.06)" onClick={goAgentCreate}>
            <img
              className="w-20px h-20px absolute left-14px top-14px"
              src="https://p2.ssl.qhimg.com/t110b9a93013dbd07941ec42352.png"
              alt=""
            />
          </div>
          <div className="text-16px font-bold text-[#356DEE]">创建智能体</div>
        </div>

        <div className="w-full relative overflow-hidden flex items-center">
          <div
            style={{
              background:
                'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
            }}
            className={[
              'w-48px h-full absolute right-0 top-0 pointer-events-none z-2',
              isLastSlide ? 'hidden' : '',
            ]}
          ></div>

          <Swiper
            ref={swiperRef}
            direction="horizontal"
            slidesPerView={'auto'}
            spaceBetween={16}
            navigation={{
              prevEl: `.agent-swiper-btn-prev`,
              nextEl: `.agent-swiper-btn-next`,
            }}
            centeredSlides={false}
            initialSlide={0}
            slidesOffsetBefore={0}
            slidesOffsetAfter={0}
            style={{
              width: '100%',
            }}
          >
            {loading
              ? // 加载状态
                Array.from({ length: 4 }).map((_, index) => (
                  <SwiperSlide key={`loading-${index}`} className="!w-138px">
                    <div
                      className={[
                        'relative w-138px h-116px p-16px gap-12px',
                        'border border-black border-opacity-6 bg-[rgba(37,45,77,0.03)] rounded-20px mar-16px mt-16px',
                        'flex flex-col items-center justify-center animate-pulse',
                      ].join(' ')}
                    >
                      <div className="size-48px rounded-full bg-gray-200"></div>
                      <div className="h-4 bg-gray-200 rounded w-20"></div>
                    </div>
                  </SwiperSlide>
                ))
              : agentList.length === 0
                ? // 空状态
                  null
                : // 正常数据渲染
                  agentList.map((agent, index) => (
                    <SwiperSlide key={agent.uuid || index} className="!w-138px">
                      <div
                        className="cursor-pointer"
                        onClick={() => handleAgentClick(agent)}
                      >
                        <div
                          className={[
                            'relative w-138px h-116px p-16px gap-12px',
                            'border border-black border-opacity-6 bg-[rgba(37,45,77,0.03)] rounded-20px mar-16px mt-16px',
                            'flex flex-col items-center justify-center',
                            'hover:bg-[rgba(37,45,77,0.06)] hover:border-black hover:rounded-20px transition-all',
                          ].join(' ')}
                        >
                          {/* 装饰性边框图片 */}
                          {Boolean(agent.pinned) && (
                            <>
                              <img
                                className="absolute top-[-2.05px] right-[-2.05px] size-48px"
                                src="https://p5.ssl.qhimg.com/t110b9a93013f94d0920fc8657c.png"
                              />
                              <img
                                className="absolute top-[-2.05px] right-43px h-2.05px w-7.12px"
                                src="https://p1.ssl.qhimg.com/t110b9a9301cc6f126a5ea16307.png"
                              />
                              <img
                                className="absolute top-43px right-[-2.05px] w-2.05px"
                                src="https://p5.ssl.qhimg.com/t110b9a9301e98ae86a43a0cade.png"
                              />
                              <img
                                className="absolute top-7px right-7.02px w-14px"
                                src="https://p5.ssl.qhimg.com/t110b9a93013a00188b707ad523.png"
                              />
                            </>
                          )}

                          {/* Agent图标 */}
                          <img
                            className="size-48px rounded-full object-cover"
                            src={
                              agent.icon ||
                              'https://p0.ssl.qhimg.com/t110b9a930152aeaa86aae6bd4b.png'
                            }
                            alt={agent.title}
                            onError={e => {
                              e.target.src =
                                'https://p0.ssl.qhimg.com/t110b9a930152aeaa86aae6bd4b.png';
                            }}
                          />

                          {/* Agent标题 */}
                          <div className="text-16px font-bold text-center w-full truncate">
                            {agent.title || '未命名智能体'}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
            <div
              className="mask w-62px h-full absolute top-0 right-0"
              style={{
                background:
                  'linear-gradient(90deg, rgba(255, 255, 255, 0.00) 5%, #FFF 100%)',
              }}
            ></div>
          </Swiper>

          <div className=""></div>
        </div>
      </div>
    </div>
  );
});
export default PersonalAgent;
